var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 21,
    viewBox: "0 0 28 21",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.03125 0.375C1.63379 0.375 0.5 1.50879 0.5 2.90625C0.5 3.70254 0.874414 4.45137 1.5125 4.93125L12.9875 13.5375C13.5887 13.9857 14.4113 13.9857 15.0125 13.5375L26.4875 4.93125C27.1256 4.45137 27.5 3.70254 27.5 2.90625C27.5 1.50879 26.3662 0.375 24.9688 0.375H3.03125ZM0.5 6.28125V17.25C0.5 19.1115 2.01348 20.625 3.875 20.625H24.125C25.9865 20.625 27.5 19.1115 27.5 17.25V6.28125L16.025 14.8875C14.8227 15.7893 13.1773 15.7893 11.975 14.8875L0.5 6.28125Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email-icon.f46488418056ac39455bbc89fb9edc2a.svg";
export { ForwardRef as ReactComponent };